import { useQuery } from '@apollo/client';

import { RealFiatAssets } from '@libs/types';
import { formatBalance } from '@libs/helpers';

import { CurrencySymbol } from 'src/constants';
import { getTotalBalanceNewQuery, HistoryPeriodEnumKeys } from 'src/gql';

import { useApiResponse } from './useApiResponse';

type UseTotalBalanceProps = {
  assetCode: RealFiatAssets;
  activeDuration: HistoryPeriodEnumKeys;
};
export const useTotalBalance = ({
  assetCode,
  activeDuration,
}: UseTotalBalanceProps) => {
  const currencySymbol = CurrencySymbol[assetCode];

  const totalBalanceRes = useQuery(getTotalBalanceNewQuery, {
    variables: {
      record: {
        valueAssetCode: assetCode,
        period: activeDuration,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const { response, loading } = useApiResponse(totalBalanceRes);
  const fiatBalance = response?.getTotalBalanceForUser.fiat || 0;
  const cryptoBalance = response?.getTotalBalanceForUser.crypto || 0;

  const formattedFixedTotalBalance = formatBalance(fiatBalance + cryptoBalance);

  return {
    fiatBalance,
    cryptoBalance,
    totalBalance: fiatBalance + cryptoBalance,
    formattedFixedTotalBalance,
    currencySymbol,
    response,
    loading,
  };
};
